import { P2Modal } from "react-bootstrap-common-script";
interface SaveDraftModalProps {
  onClose?: () => void;
  onCancel?: () => void;
  onSubmit: () => void;
  isOpen: boolean;
}

export default function SaveDraftModal({
  onClose,
  onSubmit,
  onCancel,
  isOpen
}: SaveDraftModalProps) {

  return (
    <P2Modal
      isOpen={isOpen}
      onCloseModal={onClose}
      variant="default"
      title={`Save as draft?`} // in future to change to .length
      primaryButtonText="No, remove application"
      primaryButtonFunction={onCancel}
      secondaryButtonText="Yes, save as draft"
      secondaryButtonFunction={onSubmit}
      className={"polymer-save-draft-modal"}
      children={
        <p style={{marginBottom: "32px"}}>
          Do you want to save the current application as draft?
        </p>
      }
    />
  );
}
